import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

import "swiper/css";


const slideVariants = {
  hiddenLeft: { opacity: 0, x: -80 },
  hiddenBottom: { opacity: 0, y: 80 },
  visible: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const slides = [
    {
        h1: "Wastewater Treatment Solutions Provider in Gujarat",
        h2: "Twin Lobe Blowers for Aeration Systems",
        description:
            "We supply energy-efficient twin lobe and tri lobe blowers for sewage treatment plants and effluent treatment plants. Our blowers are widely used in industrial wastewater treatment solutions requiring consistent airflow and low power consumption.",
        productImg: "/images/products/air-blower.png",
        bgImg: "/images/home/blower-carousel.png",
        // redirect: "/product/6999e3b6817d1be3e5841d08"
    },
    {
        h1: "Sludge Dewatering Machine Supplier in Ahmedabad",
        h2: "Industrial Sludge Dewatering Solutions",
        description:
            "Sera Water is a trusted sludge dewatering machine supplier in Ahmedabad offering efficient sludge dewatering solutions for ETP and STP plants. Our sludge dewatering systems reduce sludge volume, improve handling efficiency, and ensure cost-effective wastewater treatment .",
        productImg: "/images/products/sludge-dewatering.png",
        bgImg: "/images/home/slugdewatering-carousel.png",
        // redirect: "/product/699c2712759609de0d133598"
    },

    {
        h1: "Acoustic Hood Supplier in Ahmedabad",
        h2: "Industrial Noise Control Acoustic Hoods",
        description:
            "Sera Water is a trusted acoustic hood supplier in Ahmedabad providing high-quality noise control enclosures for blowers, pumps and industrial equipment. Our acoustic hoods effectively reduce sound levels, ensure compliance with noise regulations and maintain proper ventilation for ETP, STP and WTP plant applications.",
        productImg: "/images/products/acoustic-hoods.png",
        bgImg: "/images/home/dosingpump-carousel.png",
        // redirect: "/product/6999e55e817d1be3e5841d18"
    },

    {
        h1: "Filter Press Supplier in Ahmedabad",
        h2: "Industrial Filter Press Systems",
        description:
            "Filter press systems are widely used for effective solid-liquid separation in industrial wastewater treatment processes. Designed for high filtration efficiency, our filter presses help reduce sludge volume, improve cake dryness, and ensure cost-effective waste management across multiple industries.",
        productImg: "/images/products/Filter_Press.png",
        bgImg: "/images/home/dosingpump-carousel.png",
        // redirect: "/product/699c2634759609de0d13355e"
    }

];

export default function HeroCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="relative">
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop
        speed={1000}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        className="w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
  className="relative min-h-screen flex items-center bg-cover bg-center pt-24 pb-12"
  style={{ backgroundImage: `url(${slide.bgImg})` }}
>
  <div className="absolute inset-0 bg-black/70" />

  <div className="relative z-10 w-full max-w-7xl mx-auto px-4">
    <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 lg:gap-16">

      {/* IMAGE */}
      <AnimatePresence mode="wait">
        {activeIndex === index && (
          <motion.img
            key={`img-${index}`}
            src={slide.productImg}
            alt={slide.h2}
            initial={{ x: -120, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -120, opacity: 0 }}
            transition={{ duration: 1 }}
            className="w-[250px] sm:w-[275px] md:w-[320px] lg:w-[420px] mx-auto object-contain"
          />
        )}
      </AnimatePresence>

      {/* TEXT */}
      <AnimatePresence mode="wait">
        {activeIndex === index && (
          <motion.div
            key={`text-${index}`}
            initial={{ y: 120, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 120, opacity: 0 }}
            transition={{ duration: 1 }}
            className="text-white text-left lg:text-left max-w-xl mx-auto lg:mx-0"
          >
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold leading-tight">
              {slide.h1}
            </h1>

            <h2 className="mt-2 text-primary text-sm sm:text-base md:text-lg">
              {slide.h2}
            </h2>

            <p className="mt-3 text-gray-200 text-xs sm:text-sm md:text-base leading-relaxed">
              {slide.description}
            </p>

            <div className="mt-5 flex flex-wrap justify-left lg:justify-start gap-3">
              <a
                href="/contact#get-in-touch"
                className="bg-primary px-4 py-2 md:px-5 md:py-3 rounded text-dark font-semibold"
              >
                Get Quote
              </a>

              <a
                href="/products#products-section"
                className="border border-primary px-4 py-2 md:px-5 md:py-3 rounded text-primary"
              >
                View All Products
              </a>
            </div>

          </motion.div>
        )}
      </AnimatePresence>

    </div>
  </div>
</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}